import updatePresentationValues from 'reducers/updatePresentationValues'
import localStorage from 'helpers/localStorage'
import { UNIT_KEY, IMPERIAL, METRIC } from 'helpers/globals'
import changeCameraUnit from 'helpers/cameras/changeCameraUnit'

export default function updateUnit(state, action) {
  const { isImperial } = action
  const multiplier = isImperial ? 3.281 : 0.3048
  localStorage.setItem(UNIT_KEY, isImperial ? IMPERIAL : METRIC)

  const newState = Object.assign(
    {},
    state,
    {
      ui: {
        ...state.ui,
        isImperial
      }
    },
    state.cameras && state.cameras.length > 0 && {
      cameras: state.cameras.map(camera => changeCameraUnit({ camera, multiplier }))
    }
  )

  if (state.cameras && state.cameras.length > 0) {
    return updatePresentationValues(newState, { key: 'unitOfMeasurement', value: isImperial })
  }

  return newState
}



// WEBPACK FOOTER //
// ./src/reducers/updateUnit.js